import { message } from "antd";
import i18n, { I18N_NS } from "Config/i18n";

export function makeLoadingMessage() {
  return message.loading(i18n.t("Action in progress...", { ns: I18N_NS.PROJECT }) as string, 0);
}
